<template>
   
    <v-app>

        <v-app-bar color="transparent" absolute flat class="top-app-bar">   
          <v-container>
            <v-row class="align-center text-center top-row">
              <v-col cols="12" md="3">
                <router-link to="/" aria-label="King Of Web Designs Company Logo">
                  <v-img 
                    height="175"
                    contain
                    :src="companyLogo">
                  </v-img>
                </router-link>
              </v-col>
              <v-col cols class="hidden-sm-and-down text-left">
                
                  <v-btn v-for="top in topMenu" v-if="top.slug === 'services'" text x-large color="#ffc208" to="/#text">
                    {{ top.name }}
                  </v-btn>
                  <v-btn v-else text x-large color="#ffc208" :to="'/'+top.slug">
                    {{ top.name }}
                  </v-btn>
                               
              </v-col>

              <v-col cols="12" class="hidden-md-and-up">
                <v-menu
                min-width="100vw"
                min-height="100vh"
                offset-y
                bottom
                
                >
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-app-bar-nav-icon color="#ffc208"></v-app-bar-nav-icon>
                    </v-btn>
                  </template>
                  <v-list class="mobile-menu">
                    <v-list-item v-for="top in topMenu">
                      <v-list-item-content>
                        <v-list-item-title v-if="top.slug === 'services'">
                          <v-btn v-if="top.slug === 'services'" text x-large color="#ffc208" to="/#text">
                            {{ top.name }}
                          </v-btn>
                        </v-list-item-title>

                        <v-list-item-title v-else>
                          <v-btn text x-large color="#ffc208" :to="'/'+top.slug">
                            {{ top.name }}
                          </v-btn>
                        </v-list-item-title>

                       </v-list-item-content>
                    </v-list-item>   
                  </v-list>
                </v-menu>
              </v-col>

            </v-row>  
          </v-container>       
        </v-app-bar>

        <v-main>
          <router-view :key="$route.path"></router-view>

          <v-snackbar
            v-model="snackbar"
            :bottom="true"
            :color="snackbarcolor"            
            :timeout="6000"            
          >
            {{ snackbartext }}

            <template v-slot:action="{ attrs }">
              <v-btn
                dark
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </template>
          </v-snackbar>
        </v-main>
        
        
          
              <v-footer                             
                tile      
                class="font-weight-medium footer-main"
                color="black"                  
                style="color: white"                           
              >
              <v-container>
              <v-row>

                <v-col cols="12" lg="3" class="pa-16">
                  <v-row>                   
                    <v-img 
                    height="100"
                    contain
                    :src="companyLogo"                                    
                    >
                    </v-img>   
                  </v-row>

                                   
                  <v-row>                    
                    <v-col cols="12">
                      <v-btn          
                        v-for="(icon,i) in icons"
                        :key="i"               
                        fab    
                        depressed  
                        small
                        color="transparent"
                        style="margin: 10px; text-decoration: none;"
                        :href="icon.link"
                        target="_blank"
                        rel="noreferrer"
                        :aria-label="icon.name"
                        >          
                          <v-icon size="40px" color="#ffc208">{{ icon.icon }}</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>              
                </v-col>

                <v-col cols="12" md="6" lg="3" class="pa-16">
                  <div class="mb-4 footer-header" style="color: #ffc208"> Office</div>
                  
                  <v-row no-gutters>                    
                    <v-col cols="12">
                      {{ city }}
                    </v-col>
                    <v-col cols="12">
                      {{ county }}
                    </v-col>
                    <v-col cols="12">
                      {{ postcode }}
                    </v-col>
                  </v-row>

                  <div class="mt-8 mb-4 footer-header" style="color: #ffc208"> Email</div>
                  
                  <v-row>                    
                    <v-col cols="12">
                      {{ email }}
                    </v-col>                    
                  </v-row>

                  
                </v-col> 

                <v-col cols="12" md="6" lg="3" class="pa-16">

                  <div class="mb-4 footer-header" style="color: #ffc208"> WhatsApp</div>
                  
                  <v-row>                    
                    <v-col cols="12">
                      {{ phone }}
                    </v-col>                    
                  </v-row>

                  <div class="mt-11 mb-4 footer-header" style="color: #ffc208"> Mobile</div>
                  
                  <v-row>                    
                    <v-col cols="12">
                      {{ mobile }}
                    </v-col>                    
                  </v-row>
                  
                </v-col>

                <v-col cols="12" lg="3" class="pa-16">
                  <div class="mb-4 footer-header" style="color: #ffc208"> Navigate</div>
                  
                  <v-row v-for="menu in bottomMenu" class="nav-bottom">
                    <v-btn v-if="menu.slug === 'services'" text x-large color="white" to="/#text">
                    {{ menu.name }}
                  </v-btn>
                  <v-btn v-else text x-large color="white" :to="'/'+menu.slug">
                    {{ menu.name }}
                  </v-btn>
                  </v-row>
                  
                </v-col>           

                

                  </v-row>
                </v-col>
              </v-row>

              <v-row class="justify-center">
                <v-col cols="8">
                  <v-row class="justify-center">
                    <v-col v-for="menu in bottomSubMenu" class="text-center" style="color: #ffc208; opacity: 0.7; font-size: 8px;">
                      <v-btn v-if="menu.slug === 'sitemap'" text color="white" href='http://www.kingofwebdesigns.co.uk/storage/sitemap.xml' target="_blank">
                        {{ menu.name }}
                      </v-btn>
                      <v-btn v-else text color="white" :to="'/'+menu.slug">
                        {{ menu.name }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col
                  class="text-center"
                  cols="12"
                  style="color: #ffc208; opacity: 0.7;"

                >
                  &#169; {{ new Date().getFullYear() }} — <strong>King Of Web Designs</strong>
                </v-col>
              </v-row>
            </v-container>
         </v-footer>
            
          
        
      
    </v-app>
  
  
</template>

<script>
  export default {
    props: {
      
    },

    metaInfo: {
        title: 'King Of Web Designs',
        titleTemplate: '%s | We make web apps for you',

        meta: [        
        { vmid: 'og:locale', property: 'og:locale', content: 'en_GB'},
        { vmid: 'og:type', property: 'og:type', content: 'website'},
        { vmid: 'og:site_name', property: 'og:site_name', content: 'King Of Web Designs'},
        { vmid: 'og:image', property: 'og:image', content: 'http://www.kingofwebdesigns.co.uk/storage/files/filemanager/Company/Logo/KIngOfWebDesignsLogoBorder.png'},
        { vmid: 'twitter:card', name: 'twitter:card', content: 'Building web apps around you and your business.'},
        { vmid: 'twitter:site', name: 'twitter:site', content: '@kingofwebdevs'},
        ]

        
    },

    data: () => ({

      companyLogo: '',
      pages: [], 
      icons: [
      {
        name: 'Instagram',
        icon: 'mdi-instagram',
        link: 'https://www.instagram.com/kingofwebdesigns'
      },
      {
        name: 'Facebook',
        icon: 'mdi-facebook',
        link: 'https://www.facebook.com/KingOfWebDesigns'
      },
      {
        name: 'Twitter',
        icon: 'mdi-twitter',
        link: 'https://twitter.com/KingOfWebDevs'
      }, 
             
      ], 
      snackbar: false,
      snackbartext: '',
      snackbarcolor: '',  
      city: '',
      county: '',
      postcode: '',
      phone: '',
      mobile: '',
      email: '',    
       
    }), 

    created () {
        this.initialize()
    },

    computed: {

        topMenu: function() {
            
            var topMenu = [];            
            topMenu =  this.pages.filter(function(menu){
              return menu.top_menu === 1
            });
            return topMenu;
        },

        bottomMenu: function() {
            
            var bottomMenu = [];            
            bottomMenu =  this.pages.filter(function(menu){
              return menu.bottom_menu === 1
            });
            return bottomMenu;
        },

        bottomSubMenu: function() {
            
            var bottomSubMenu = [];            
            bottomSubMenu =  this.pages.filter(function(menu){
              return menu.bottom_submenu === 1
            });
            return bottomSubMenu;
        },

        logo: function() {
          return this.company[0].logo;
        }
    },

    methods: {

      initialize () {
          axios.get('/api/company-info').then(response => {
            this.company = response.data.data;
            this.companyLogo = response.data.data[0].logo;
            this.city = response.data.data[0].city;
            this.county = response.data.data[0].county;
            this.postcode = response.data.data[0].postcode;
            this.phone = response.data.data[0].telephone;
            this.mobile = response.data.data[0].mobile;
            this.email = response.data.data[0].email;
          });

          axios.get('/api/pages').then(response => {
            this.pages = response.data.data; 
          });
      },

      validateBeforeSend () {

          this.$refs.form.validate(); 

          if(this.$refs.form.validate() == true){

              this.sendMessage();

          } else {

            this.snackbartext = 'Please check contact form for errors'
            this.snackbarcolor = 'error'
            this.snackbar = true;
          }

        },

      sendMessage () {

            axios.post('/api/messages', this.messageForm)
              .catch(error => 
              {
                if(error.response.status == 422)
                  {
                    this.snackbartext = 'Please check contact form for errors'
                    this.snackbarcolor = 'error'
                    this.snackbar = true;                    
                  }
              })
            .then((response) => 
              {     
                    this.$refs.form.reset()
                    this.snackbartext = response.data;
                    this.snackbarcolor = 'success'
                    this.snackbar = true;                    
              });        
      },
    }
  }
</script>
<style>

  .v-application {
    font-family: NeueHaasGroteskText Pro,sans-serif;
    line-height: 1.8;
    letter-spacing: .025em;
    color: #2e2e2e;
  }

  h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6, .header-5, .footer-header {
    text-transform: uppercase;
    line-height: 1.3;
    letter-spacing: 4px;
    word-break: break-word !important;
  }

  .header-5 {    
    font-size: 1.125rem;
  }

  .footer-header {
    font-size: 1.35rem;
    display: block;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }

  .container {
    max-width: 90%;
  }

  .black-to-white {
    -webkit-filter: grayscale(1) invert(1);
    filter: grayscale(1) invert(1);
  }

  .theme--dark.v-label {
    opacity: 1 !important;
  }

  .RRChny {
    display: none;
  }

  .top-app-bar, .top-app-bar .v-toolbar__content {
    height: 175px !important;
  }


@media all and (max-width: 1330px) { 

  h1, .h1 {
    font-size: 1.46rem;
  }  

  h5, .h5, .header-5 {
    font-size: 0.9rem;
  }

}

@media all and (max-width: 1220px) { 

  

}

@media all and (max-width: 1100px) { 

  

}

@media all and (max-width: 1024px) { 

  .footer-main {
    text-align: center;
  }

  .footer-main .pa-16 {
    padding: 4px !important;
  }

  .nav-bottom {
    justify-content: center !important;
  } 
  

}

@media all and (max-width: 959px) { 
  

} 

@media all and (max-width: 839px) { 

  .top-app-bar, .top-app-bar .v-toolbar__content {
    height: 225px !important;
  }

  .mobile-menu {
    text-align: center;
    justify-content: center;
    background-color: black !important;
  }
  
  
} 

 

@media all and (max-width: 480px) { 

  body {
      overflow-x: hidden;
  }

  h1, .h1 {
    font-size: 1.59rem;
  }

  h2, .h2 {
    font-size: 1.3rem;
  }  


  .top-row .col-12 {
    padding: 0px !important;
  }



}

@media all and (max-width: 375px) { 
  

  h1, .h1 {
    font-size: 1.4rem;
  }

}

@media only screen and (max-width: 1366px) and (orientation: landscape) {  
  
}

@media only screen and (max-width: 1024px) and (orientation: landscape) {  
  
}

@media only screen and (max-width: 839px) and (orientation: landscape) {

  
}




</style>